// iter335 — aktif kayıtlar üstte (mevcut sıra korunur), tamamlananlar altta; tamamlananlar tarihe göre yeni → eski.
export function doneLast(rows, isDone, doneDate) {
  const active = [], done = [];
  (rows || []).forEach(r => (isDone(r) ? done : active).push(r));
  done.sort((a, b) => String(doneDate(b) || "").localeCompare(String(doneDate(a) || "")));
  return [...active, ...done];
}
